// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"82353ffa","732":"238d8be2","977":"518dc481"}[chunkId] + ".chunk.js");